export enum $formFields {
  entriesAmount = 'entriesAmount',
  issueStatus = 'issueStatus',
  reason = 'reason',
  manualAuditIssueIds = 'manualAuditIssueIds',
}
